import script from "./ProductDescriptionSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDescriptionSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductDescriptionSkeleton.vue?vue&type=style&index=0&id=508de328&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508de328"]])

export default __exports__